import React from "react";
const TrendingSvg = () => {
  return (
    <svg
      width="24"
      height="14"
      viewBox="0 0 24 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0.888889C16 0.397969 16.398 0 16.8889 0H23.1111C23.602 0 24 0.397969 24 0.888889V7.11111C24 7.60203 23.602 8 23.1111 8C22.6202 8 22.2222 7.60203 22.2222 7.11111V1.77778H16.8889C16.398 1.77778 16 1.37981 16 0.888889Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7505 1.25384C23.0832 1.5923 23.0832 2.14104 22.7505 2.47949L15.4369 9.9203C15.4369 9.92032 15.4368 9.92034 15.4368 9.92037C15.1995 10.1618 14.9178 10.3534 14.6077 10.4841C14.2976 10.6148 13.9653 10.682 13.6296 10.682C13.294 10.682 12.9616 10.6148 12.6515 10.4841C12.3414 10.3534 12.0597 10.1618 11.8224 9.9203L9.12101 7.17195L9.12094 7.17188C9.04183 7.09138 8.94792 7.02753 8.84455 6.98396C8.74119 6.94039 8.6304 6.91797 8.51852 6.91797C8.40664 6.91797 8.29585 6.94039 8.19248 6.98396C8.08912 7.02753 7.9952 7.09138 7.9161 7.17188L7.91603 7.17195L1.4542 13.7462C1.12153 14.0846 0.58217 14.0846 0.249502 13.7462C-0.0831672 13.4077 -0.0831672 12.859 0.249502 12.5205L6.71126 5.94637C6.94857 5.70487 7.23032 5.51331 7.54042 5.38261C7.85051 5.25191 8.18287 5.18464 8.51852 5.18464C8.85417 5.18464 9.18653 5.25191 9.49662 5.38261C9.80671 5.51331 10.0885 5.70487 10.3258 5.94637L13.0271 8.69472L13.0272 8.69479C13.1063 8.77529 13.2002 8.83914 13.3036 8.88271C13.407 8.92627 13.5177 8.9487 13.6296 8.9487C13.7415 8.9487 13.8523 8.92627 13.9557 8.88271C14.059 8.83914 14.1529 8.77529 14.232 8.69479L14.2321 8.69472L21.5458 1.25384C21.8785 0.915386 22.4178 0.915386 22.7505 1.25384Z"
      />
    </svg>
  );
};

export default TrendingSvg;
